import './FairnessModal.scss';
import { observer } from 'mobx-react';
import { ModalWrapper } from '../../platform/components/modal/ModalWrapper';
import doneIcon from '../../assets/icons/done.svg';
import copyIcon from '../../assets/icons/copy.svg';
import pasteIcon from '../../assets/icons/paste.svg';
import { useState } from 'react';
import { roundStore, useTranslation } from '../../platform/stores';

export const FairnessModal = observer(() => {
  const t = useTranslation();
  const { checkHashRound, setCheckHashRound, } = roundStore;
  const [aboutModalState, setAboutModalState] = useState(false);
  const [keyCopyDone, setKeyCopyDone] = useState(false);
  const [saltCopyDone, setSaltCopyDone] = useState(false);
  const [hashCopyDone, setHashCopyDone] = useState(false);
  const [copiedKey, setCopiedKey] = useState('');
  const [copiedSalt, setCopiedSalt] = useState('');
  const [hash, setHash] = useState('');
  const [copiedValue, setCopiedValue] = useState('');

  const copyKey = () => {
    if (checkHashRound?.key) {
      setCopiedValue(checkHashRound.key);
      setKeyCopyDone(true);
      setTimeout(() => {
        setKeyCopyDone(false);
      }, 500);
      // navigator.clipboard.writeText(checkHashRound.key).then(() => {
      //   setKeyCopyDone(true);
      //   setTimeout(() => {
      //     setKeyCopyDone(false);
      //   }, 500);
      // });
    }
  }

  const copySalt = () => {
    if (checkHashRound?.salt) {
      setCopiedValue(checkHashRound.salt);
      setSaltCopyDone(true);
      setTimeout(() => {
        setSaltCopyDone(false);
      }, 500);
      // navigator.clipboard.writeText(checkHashRound.salt).then(() => {
      //   setSaltCopyDone(true);
      //   setTimeout(() => {
      //     setSaltCopyDone(false);
      //   }, 500);
      // });
    }
  }

  const copyHash = () => {
    if (checkHashRound?.hash) {
      setCopiedValue(checkHashRound.hash);
      setHashCopyDone(true);
      setTimeout(() => {
        setHashCopyDone(false);
      }, 500);
      // navigator.clipboard.writeText(checkHashRound.hash).then(() => {
      //   setHashCopyDone(true);
      //   setTimeout(() => {
      //     setHashCopyDone(false);
      //   }, 500);
      // });
    }
  }

  const pasteKey = () => {
    setCopiedKey(copiedValue);
  }

  const pasteSalt = () => {
    setCopiedSalt(copiedValue);
  }

  const close = () => {
    if (aboutModalState) {
      setAboutModalState(false);
    } else {
      setCheckHashRound(null);
      setCopiedKey('');
      setCopiedSalt('');
      setHash('');
    }
  }

  const calculateHash = () => {
    crypto.subtle
      .digest('SHA-512', new TextEncoder().encode(copiedKey + copiedSalt))
      .then(h => {
        let hexes = [],
          view = new DataView(h);
        for (let i = 0; i < view.byteLength; i += 4)
          hexes.push(('00000000' + view.getUint32(i).toString(16)).slice(-8));
        const result = hexes.join('').toUpperCase();
        setHash(result);
      });
  }

  return (
    <ModalWrapper hidden={!checkHashRound} onClose={() => close()}>
      <div className="fairness-modal-component">
        <div className="close-btn" onClick={() => close()}></div>
        {
          !aboutModalState
            ?
            <>
              <div className="first-section">
                <div className="title">{t('FAIRNESS_MODAL_FAIRNESS')}</div>
                <div className="flex-between">
                  <div className="half relative">
                    <input type="text" readOnly placeholder={t('FAIRNESS_MODAL_KEY')} value={checkHashRound?.key || ''}/>
                    {
                      keyCopyDone
                        ?
                        <img className="icon" src={doneIcon} alt="Done icon"/>
                        :
                        <img className="icon" src={copyIcon} alt="Copy icon" onClick={() => copyKey()}/>
                    }
                  </div>
                  <div className="half relative">
                    <input type="text" readOnly placeholder={t('FAIRNESS_MODAL_SALT')} value={checkHashRound?.salt || ''}/>
                    {
                      saltCopyDone
                        ?
                        <img className="icon" src={doneIcon} alt="Done icon"/>
                        :
                        <img className="icon" src={copyIcon} alt="Copy icon" onClick={() => copySalt()}/>
                    }
                  </div>
                </div>
                <div className="margin-top-20 relative">
                  <input type="text" readOnly placeholder={t('FAIRNESS_MODAL_HASH')} value={checkHashRound?.hash || ''}/>
                  {
                    hashCopyDone
                      ?
                      <img className="icon" src={doneIcon} alt="Done icon"/>
                      :
                      <img className="icon" src={copyIcon} alt="Copy icon" onClick={() => copyHash()}/>
                  }
                </div>
              </div>
              <div className="second-section">
                <div className="title">{t('FAIRNESS_MODAL_CHECK_HASH_CODE')}</div>
                <div className="flex-between">
                  <div className="half relative">
                    <input type="text" readOnly placeholder={t('FAIRNESS_MODAL_PASTE_KEY')} value={copiedKey || ''}/>
                    <img className="icon" src={pasteIcon} alt="Paste icon" onClick={() => pasteKey()}/>
                  </div>
                  <div className="half relative">
                    <input type="text" readOnly placeholder={t('FAIRNESS_MODAL_PASTE_SALT')} value={copiedSalt || ''}/>
                    <img className="icon" src={pasteIcon} alt="Paste icon" onClick={() => pasteSalt()}/>
                  </div>
                </div>
                <div className="margin-top-20 relative">
                  <input type="text" className="no-padding" placeholder={t('FAIRNESS_MODAL_HASH')} readOnly value={hash || ''}/>
                </div>
                <div className="check-button flex-center" onClick={() => calculateHash()}>{t('FAIRNESS_MODAL_CHECK')}</div>
              </div>
              <div className="about flex-center">
                <div className="flex-center cursor-pointer" onClick={() => setAboutModalState(true)}>
                  <div className="about-icon flex-center">?</div>
                  {t('FAIRNESS_MODAL_ABOUT_HASH_CODE')}
                </div>
              </div>
            </>
            :
            <>
              <div className="title">{t('FAIRNESS_MODAL_ABOUT_HASH_CODE')}</div>
              <pre className="about-hash-code-content">{t('FAIRNESS_MODAL_ABOUT_HASH_CODE_TEXT')}</pre>
            </>
        }

      </div>
    </ModalWrapper>
  );
});
